<template>
	<form action="" class="user-form">
		<div class="input-group">
			<label for="" class="input-group__label">USERNAME:</label>
			<input
				type="text"
				class="input-group__input"
				placeholder="Enter a user name"
			/>
		</div>

		<div class="input-group">
			<label for="" class="input-group__label">FULL NAME:</label>
			<input
				type="text"
				class="input-group__input"
				placeholder="Enter full name"
			/>
		</div>

		<div class="input-group">
			<label for="" class="input-group__label">PASSWORD:</label>
			<input
				type="text"
				class="input-group__input"
				placeholder="Enter password"
			/>
		</div>
		<div class="input-group">
			<label for="" class="input-group__label">PASSWORD:</label>
			<input
				type="text"
				class="input-group__input"
				placeholder="Confirm password"
			/>
		</div>
		<div class="input-group">
			<label for="" class="input-group__label">USER GROUP:</label>
			<select name="" class="input-group__select">
				<option value="user" selected>Users</option>
				<option value="admin">Admin</option>
			</select>
		</div>
		<input
			type="submit"
			value="submit"
			class="btn btn--red user-form__submit"
		/>
	</form>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
	name: "",
	components: {}
});
</script>

<style lang="scss" scoped>
.user-form {
	&__submit {
		text-transform: uppercase;
		margin: 20px auto 10px;
		padding: 3px 20px;
		display: block;
	}
}

.input-group {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 7px 0;

	&__label {
		font-weight: 600;
		font-size: 12px;
		width: 100px;
	}

	&__select,
	&__input {
		padding: 5px 10px;
		border-radius: 5px;
		border: 1px solid $color7;
	}

	&__select {
		text-align-last: center;
		font-size: 14px;
		width: 100px;
		width: 200px;
	}

	&__input {
		width: (200px - 10px * 2);
		font-size: 14px;
	}
}
</style>